/**
 * @generated SignedSource<<9cd950d6af6ce929e4f203d2632bb595>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainPictureUrl",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "SearchPayload",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductElastic",
        "kind": "LinkedField",
        "name": "productsItems",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "catalogIconUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductFamilyElastic",
            "kind": "LinkedField",
            "name": "families",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productsTotalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ServiceElastic",
        "kind": "LinkedField",
        "name": "servicesItems",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pictureURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceFamilyElastic",
            "kind": "LinkedField",
            "name": "families",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyColor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "servicesTotalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ArticleElastic",
        "kind": "LinkedField",
        "name": "articlesItems",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "articlesTotalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InformationElastic",
        "kind": "LinkedField",
        "name": "informationsItems",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "informationsTotalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchScreenQuery",
    "selections": (v5/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SearchScreenQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "028f2922609e46fffdf843400dd0219e",
    "id": null,
    "metadata": {},
    "name": "SearchScreenQuery",
    "operationKind": "query",
    "text": "query SearchScreenQuery(\n  $search: String!\n) {\n  search(search: $search) {\n    productsItems {\n      rowId\n      name\n      catalogIconUrl\n      price\n      serviceId\n      families {\n        rowId\n      }\n    }\n    productsTotalCount\n    servicesItems {\n      rowId\n      name\n      pictureURL\n      logoURL\n      families {\n        rowId\n        familyColor\n      }\n    }\n    servicesTotalCount\n    articlesItems {\n      rowId\n      title\n      mainPictureUrl\n      publishedAt\n    }\n    articlesTotalCount\n    informationsItems {\n      rowId\n      title\n      mainPictureUrl\n    }\n    informationsTotalCount\n  }\n}\n"
  }
};
})();

node.hash = "ddc3733bd7438d1a4236e250f453931b";

module.exports = node;
